import {
    Stack,
    styled,
    Typography,
    Box,
    ButtonBase,
    Divider,
    LinearProgress,
} from "@mui/material";
import FlexBetween from "../../components/flexbox/FlexBetween";
import FlexRowAlign from "../../components/flexbox/FlexRowAlign";
import { useState } from "react";
import { fCurrency } from "../../utils/format";
import Increase from "../../page-sections/hompage/Increase";
import useMetrics from "../../hooks/useMetrics";
import Decimal from "decimal.js";
import moment from "moment";

export default function Metrics() {
    const { metrics } = useMetrics()
    const [tabIndex, setTabIndex] = useState(0)
    const percen = new Decimal(metrics?.totalMined ?? 0).sub(metrics?.totalSupply ?? 0).mul(100).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    return (
        <MetricsContainer>
            <Box flexGrow={1} />
            <Stack px={2} >
                <Stack p={1} spacing={1} sx={{ border: '1px dashed #7F7F7F' }}>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Mining date]</Typography>
                        <Typography>{moment(new Date).format('MM-DD-YYYY HH:mm')}</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Total Mined]</Typography>
                        <Typography>{fCurrency(metrics?.totalMined ?? 0)}</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Total Supply]</Typography>
                        <Typography>{fCurrency(metrics?.totalSupply ?? 0)}</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                    <LinearProgress sx={{
                        background: '#2C2C2C', borderRadius: 0, height: 15, '& .MuiLinearProgress-bar': {
                            background: '#89EC5D'
                        }
                    }} variant="determinate" value={percen} />
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Total Bandwidth Shared]</Typography>
                        <Typography>{fCurrency(metrics?.totalBandwidth ?? 0)} GB</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D' }}>[Total Holders]</Typography>
                        <Typography>{fCurrency(metrics?.totalHolder ?? 0)}</Typography>
                        <Box flexGrow={1} />
                    </FlexBetween>
                </Stack>
            </Stack>
            <Box flexGrow={1} />
            <Divider sx={{
                background: '#8AEB5D',
                color: "#000",
                fontWeight: 500,
                lineHeight: "30px",
                my: 2,
                '&:before, &:after': {
                    borderTop: "thin dashed #000"
                }
            }}>[Leaderboard]</Divider>
            <FlexRowAlign gap={2} pb={2} px={2} justifyContent="flex-start">
                <ButtonBase onClick={() => setTabIndex(0)} sx={{ opacity: tabIndex === 0 ? 1 : 0.4, fontWeight: 700 }}>Miner</ButtonBase>
                <Divider orientation="vertical" sx={{ height: 10, opacity: 1 }} />
                <ButtonBase onClick={() => setTabIndex(1)} sx={{ opacity: tabIndex === 1 ? 1 : 0.4, fontWeight: 700 }}>Donation</ButtonBase>
                <Divider orientation="vertical" sx={{ height: 10, opacity: 1 }} />
                <ButtonBase onClick={() => setTabIndex(2)} sx={{ opacity: tabIndex === 2 ? 1 : 0.4, fontWeight: 700 }}>Invite</ButtonBase>
            </FlexRowAlign>
            <FlexBetween px={2} pb={1}>
                <Typography sx={{ minWidth: 100, color: '#89EC5D' }}>{`<No.>`}</Typography>
                <Typography sx={{ width: '100%', color: '#89EC5D' }}>{`<Name>`}</Typography>
                <Typography sx={{ color: '#89EC5D' }}>{`<Earned>`}</Typography>
            </FlexBetween>
            <Stack pb={2.5} spacing={0.5} px={2} flexGrow={1} sx={{ height: '38vh', overflow: 'scroll' }}>
                {
                    metrics?.leaderBoard?.map((item, index) => <Stack key={item.refCode}>
                        <FlexBetween>
                            <Typography sx={{ minWidth: 100 }}>{index + 1}</Typography>
                            <Typography sx={{ width: '100%', color: '#FFD900' }}>@{item.userName}</Typography>
                            <Typography>{fCurrency(item.sum)}</Typography>
                        </FlexBetween>
                        <Divider />
                    </Stack>)
                }
            </Stack>
        </MetricsContainer >
    );
}

const MetricsContainer = styled(Stack)(({ theme }) => ({
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: 'relative',
    minHeight: '100%',
}));